import React, { Component } from 'react';
import Button from '@material-ui/core/Button';
import Modal from '@material-ui/core/Modal';
import { ToastContainer, toast } from 'react-toastify';
import TextField from '@material-ui/core/TextField';
import 'react-toastify/dist/ReactToastify.css';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import { Link } from "react-router-dom";


const theme = createMuiTheme({
    direction: 'rtl', // Both here and <body dir="rtl">
    typography: {
        useNextVariants: true,
    },
});

export default class Comments extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false,
            comment: '',
            islogin: false,
            newcomments: [],
        }
        this.handleOpen = this.handleOpen.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handelchange = this.handelchange.bind(this);
        this.submit = this.submit.bind(this);

    }

    handleOpen() {
        this.setState({ open: true });
    };

    handleClose() {
        this.setState({ open: false });
    };
    handelchange(e) {
        this.setState({ comment: e.target.value })
    }
    submit(e) {
        e.preventDefault();
        // console.log(this.state.comment)
        toast.success('نظر با موفقیت ثبت گردید',
            {
                position: "top-right",
                autoClose: 1500,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                draggablePercent: 60
            });
        let newcomment = { date: '1397/010/25', desc: this.state.comment };
        this.setState({
            newcomments: this.state.newcomments.concat([newcomment]),
            open: false,

        })
    }

    componentDidMount() {
        // console.log(localStorage)

        try {
            if (localStorage.length !== 0 && localStorage.api_token) {
                this.setState({ islogin: true })
                console.log("Login")
            } else {
                this.setState({ islogin: false })
                console.log("Not login")
            }
        } catch (err) {
            console.log(err)
        }
    }


    render() {

        return (
            <div className='Comments' >
                <div className='Comments-titles'>
                    <span className='small-content-title' >
                        دیدگاه ها
                    </span>
                    {this.state.islogin === true ?
                        <Button className='button add-comments' onClick={this.handleOpen} >
                            ارسال دیدگاه
                        </Button>
                        :
                        <span className="login-first">
                            <Link to="/login">
                                <Button className='button add-comments' >
                                    وارد شوید
                                </Button>
                            </Link>
                        </span>
                    }

                </div>
                <div className='Comments-form'>
                    <div className='top-comment-header' >
                        <span className='avatar' >
                            نام کاربر
                        </span>
                        <span className='Comments-date'>
                            1397/05/06
                        </span>
                    </div>
                    <div className='comment-body' >
                        <p>
                            لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است.
                        </p>
                    </div>
                </div>
                {console.log(this.state.newcomments)}
                {this.state.newcomments.length !== 0 && this.state.newcomments.map((newcomment, i) => {
                    return (
                        <div key={i} className='Comments-form'>
                            <div className='top-comment-header' >
                                <span className='avatar' >
                                    نام دیدگاه
                        </span>
                                <span className='Comments-date'>
                                    {newcomment.date}
                                </span>
                            </div>
                            <div className='comment-body' >
                                <p>
                                    {newcomment.desc}
                                </p>
                            </div>
                        </div>)
                })}



                <Modal
                    aria-labelledby="simple-modal-title"
                    aria-describedby="simple-modal-description"
                    open={this.state.open}
                    onClose={this.handleClose}
                >
                    <div className='login-modal'  >

                        <div className='LoginSignin'>
                            <h3>ارسال نظر</h3>
                            <p>
                                متن مورد نظر خود را تایپ نمایید.
                            </p>
                            <form className='container' autoComplete="on" onSubmit={this.submit}>
                                <MuiThemeProvider theme={theme}>
                                    <div dir="rtl">
                                        <TextField
                                            required
                                            label="متن نظر"
                                            className='textField login-input'
                                            margin="normal"

                                            onChange={this.handelchange}
                                            name='comment'
                                        />

                                        <div className='login-buttons' >
                                            <Button variant="contained" className='button login-but' type="submit" >
                                                ارسال نظر
                                            <i className="fas fa-sign-in-alt"></i>
                                            </Button>

                                        </div>

                                    </div>
                                </MuiThemeProvider>
                            </form>





                        </div>
                    </div>
                </Modal>

                <ToastContainer
                    position="top-right"
                    autoClose={2500}
                    hideProgressBar
                    newestOnTop
                    closeOnClick
                    rtl={false}
                    pauseOnVisibilityChange={false}
                    draggable={false}
                    pauseOnHover
                />
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/containers/merchants/comments.jsx